export default __webpack_public_path__ + "static/media/ingredientsColor.78f252fe.png";